import { http } from "../../../shared/api/http"

/* ===================== TYPES ===================== */

export type Education = {
  id: string
  user_id: string
  institution: string
  degree: string
  start_year: number
  end_year?: number
}

export type EducationListResponse = {
  items: Education[]
  total: number
}

/* ===================== API ===================== */

export const listMyEducationsApi = () => {
  return http.get<EducationListResponse>("api/users/me/educations")
}

export const createEducationApi = (
  data: Omit<Education, "id" | "user_id">
) => {
  return http.post<Education>("api/users/me/educations", data)
}

export const deleteEducationApi = (id: string) => {
  return http.delete<void>(`api/users/me/educations/${id}`)
}
